import { render } from "./Column202504.vue?vue&type=template&id=1ce4f041&scoped=true"
import script from "./Column202504.vue?vue&type=script&lang=js"
export * from "./Column202504.vue?vue&type=script&lang=js"

import "./Column202504.vue?vue&type=style&index=0&id=1ce4f041&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce4f041"]])

export default __exports__